import React from 'react';
import './playlist-artwork.scss';

export default class PlaylistArtwork extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      artwork: props.artwork || {},
      showDetails: props.showDetails || false,
      showImage: props.showImage || false,
      show: false,
    }

    this.getArtworkUrl = this.getArtworkUrl.bind(this);
    this.getArtworkName = this.getArtworkName.bind(this);
    this.getArtistName = this.getArtistName.bind(this);
  }

  componentWillReceiveProps({ showDetails, artwork, showImage }) {
    this.setState({ showDetails, artwork, showImage });
  }

  getArtworkUrl(artwork) {
    const { showImage } = this.props;
    if (!showImage) return '';

    if (artwork && artwork.media && artwork.media.image && artwork.media.image.low && artwork.media.image.low.landscape) {
      return artwork.media.image.low.landscape || artwork.media.image.low;
    }
    return '';
  }

  getArtworkName(artwork) {
    if (artwork && artwork.name) {
      return artwork.name;
    }
    return '';
  }

  getArtistName(artwork) {
    if (artwork && artwork._embedded && artwork._embedded.artist && artwork._embedded.artist.givenName) {
      return artwork._embedded.artist.givenName + " " + artwork._embedded.artist.surname;
    }
    return '';
  }

  render() {
    const { artwork } = this.state;
    return (
      <div className={this.state.showDetails ? "playlist-artwork playlist-artwork--details" : "playlist-artwork"}>
        {this.state.showImage ? <img className={this.state.show ? "playlist-artwork__image" : "none"} src={this.getArtworkUrl(artwork)} onLoad={() => { this.state.show ? null : this.setState({ show: true }) }} /> : null}
        {
          this.state.showDetails ?
            <div className="playlist-artwork__details">
              <div className="playlist-artwork__details__container">
                <h6 className="h--spacing-sm">{this.getArtworkName(artwork)}</h6>
                <h6 className="h--no-spacing h--normalize-weight">{this.getArtistName(artwork)}</h6>
              </div>
            </div> :
            null
        }
      </div>
    )
  }
};
